"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinnedMessage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const stream_chat_react_1 = require("stream-chat-react");
const UserIcon_1 = require("./UserIcon");
const ChevronDown_1 = __importDefault(require("../../assets/icons/ChevronDown"));
const PinIcon_1 = __importDefault(require("../../assets/icons/PinIcon"));
const UnpinIcon_1 = __importDefault(require("../../assets/icons/UnpinIcon"));
const PinnedMessage = ({ message, messageTextList, info }) => {
    var _a, _b;
    const space = " ";
    const [direction, setDirection] = (0, react_1.useState)("up");
    const { client } = (0, stream_chat_react_1.useChatContext)();
    const unpinMessage = async () => {
        await client.unpinMessage(message);
    };
    const unpinPreviousMessages = async (client) => {
        const channelState = await client
            .channel("livestream", info.channelId)
            .query({});
        channelState.pinned_messages
            .sort((a, b) => {
            if (!a.pinned_at || !b.pinned_at) {
                return 0;
            }
            if (a.pinned_at < b.pinned_at) {
                return -1;
            }
            if (a.pinned_at > b.pinned_at) {
                return 1;
            }
            return 0;
        })
            .forEach(async (msg, index) => {
            if (index != channelState.pinned_messages.length - 1) {
                client.unpinMessage({ id: msg.id });
            }
        });
    };
    const splitMessageText = (text) => {
        let localText = "";
        let charLimit = 25;
        if (text.length < charLimit) {
            charLimit = text.length;
        }
        for (let i = 0; i < charLimit; i++) {
            localText += text[i];
        }
        return localText;
    };
    const appendDots = (text) => {
        return `${text}...`;
    };
    const toggleInfo = (0, react_1.useCallback)(() => {
        if (direction == "up") {
            setDirection("down");
        }
        else {
            setDirection("up");
        }
    }, [direction]);
    if (!message.user) {
        return null;
    }
    (0, react_1.useEffect)(() => {
        if (!client)
            return;
        unpinPreviousMessages(client);
    }, [unpinPreviousMessages, client]);
    if (direction == "down") {
        if (!message.text) {
            return null;
        }
        const text = appendDots(splitMessageText(message.text));
        return ((0, jsx_runtime_1.jsx)("div", { className: "pinned-message__outer-wrapper", children: (0, jsx_runtime_1.jsxs)("div", { className: "pinned-message__container", children: [(0, jsx_runtime_1.jsxs)("div", { className: "pinned-message__message-container", children: [(0, jsx_runtime_1.jsxs)("div", { className: "pinned-message__row pinned-message__info", children: [(0, jsx_runtime_1.jsx)(PinIcon_1.default, {}), " Pinned by", space, (0, jsx_runtime_1.jsx)(UserIcon_1.UserIcon, { type: message.user.role, width: 16, height: 16 }), space, message.user.name || message.user.id] }), (0, jsx_runtime_1.jsx)("div", { className: "pinned-message__row", children: (0, jsx_runtime_1.jsx)("div", { className: "pinned-message__message", children: text }) })] }), ((_a = client.user) === null || _a === void 0 ? void 0 : _a.role) == "moderator" && ((0, jsx_runtime_1.jsx)("a", { title: "Unpin message", style: { cursor: "pointer" }, onClick: (_) => unpinMessage(), className: "pinned-message__unpin-message", children: (0, jsx_runtime_1.jsx)(UnpinIcon_1.default, {}) })), (0, jsx_runtime_1.jsx)("a", { title: "Hide info", style: { cursor: "pointer" }, onClick: toggleInfo, className: "pinned-message__hide-info", children: (0, jsx_runtime_1.jsx)(ChevronDown_1.default, { direction: direction }) })] }) }));
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: "pinned-message__outer-wrapper", children: (0, jsx_runtime_1.jsxs)("div", { className: "pinned-message__container", children: [(0, jsx_runtime_1.jsxs)("div", { className: "pinned-message__message-container", children: [(0, jsx_runtime_1.jsxs)("div", { className: "pinned-message__row pinned-message__info", children: [(0, jsx_runtime_1.jsx)(PinIcon_1.default, {}), " Pinned by", space, (0, jsx_runtime_1.jsx)(UserIcon_1.UserIcon, { type: message.user.role, width: 16, height: 16 }), space, message.user.name || message.user.id] }), (0, jsx_runtime_1.jsx)("div", { className: "pinned-message__row", children: (0, jsx_runtime_1.jsxs)("div", { className: "pinned-message__message", children: [messageTextList.messagePartOne, messageTextList.messagePartTwo, messageTextList.messagePartThree] }) })] }), ((_b = client.user) === null || _b === void 0 ? void 0 : _b.role) == "moderator" && ((0, jsx_runtime_1.jsx)("a", { title: "Unpin message", style: { cursor: "pointer" }, onClick: (_) => unpinMessage(), className: "pinned-message__unpin-message", children: (0, jsx_runtime_1.jsx)(UnpinIcon_1.default, {}) })), (0, jsx_runtime_1.jsx)("a", { title: "Hide info", style: { cursor: "pointer" }, onClick: toggleInfo, className: "pinned-message__hide-info", children: (0, jsx_runtime_1.jsx)(ChevronDown_1.default, { direction: direction }) })] }) }));
};
exports.PinnedMessage = PinnedMessage;
